import { DefaultError } from '@tanstack/query-core';
import { UseSuspenseQueryOptions, useQuery } from '@tanstack/react-query';
import { EngageMessagePreviewStatusResponse, fetchEngageMessagePreviewStatus } from 'api/engage';
import { useCurrentLetter } from 'assets/js/pages/engage/letters/useCurrentLetter';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { conditionallyFetchOrNull } from 'helpers/reactQuery';
import { accountQueryKeys } from 'queries/account-query-keys';

interface Options
    extends Omit<
        UseSuspenseQueryOptions<
            EngageMessagePreviewStatusResponse | null,
            DefaultError,
            EngageMessagePreviewStatusResponse,
            any
        >,
        'queryKey'
    > {}
const PREVIEW_STATUS_REFETCH_INTERVAL = 5000;
const useCurrentLetterPreview = (options: Options = {} as Options) => {
    const { accountId } = useCurrentAccount();
    const { data: letter } = useCurrentLetter();
    return useQuery({
        queryKey: accountQueryKeys.engageMessagePreviewStatus(accountId, letter.id),
        queryFn: () =>
            conditionallyFetchOrNull(
                () => fetchEngageMessagePreviewStatus(accountId, letter.id),
                letter.settings.send_to_print_and_mail_service,
            ),
        refetchInterval: query => {
            if (query.state.status === 'error') {
                return false;
            }
            const status = query.state.data?.status;
            return status ? false : PREVIEW_STATUS_REFETCH_INTERVAL;
        },
        ...options,
    });
};

export { useCurrentLetterPreview };
